import { urls, baseUrl } from '../constants/app';
import moment from 'moment';
import axios from 'axios';
import request from './utils/request';
axios.defaults.baseURL = baseUrl;

export function fetchPopularGoods() {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_STATISTICS_LOADER', name: 'orderGoods', loading: true });
        dispatch({ type: 'SET_STATISTICS_ERROR', name: 'orderGoods', error: null });

        const filters = getState().statistics.orderGoods.filters;
        const params = {};
        if (filters.city && filters.city.value !== 'all') {
            params['city'] = filters.city.value;
        }

        if (filters.createdStartDate) {
            params['created_at_gte'] = moment(filters.createdStartDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        }
    
        if (filters.createdEndDate) {
            params['created_at_lte'] = moment(filters.createdEndDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        }

        return request({ method: 'get', url: urls.ordergoods+'/popularGoods', params })
            .then(result => {
                dispatch({ type: 'SET_STATISTICS_LOADER', name: 'orderGoods', loading: false });
                return result;
            })
            .catch(error => {
                dispatch({ type: 'SET_STATISTICS_ERROR', name: 'orderGoods', error });
                dispatch({ type: 'SET_STATISTICS_LOADER', name: 'orderGoods', loading: false });
            });
    }
}

export function fetchOrderGoods() {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_STATISTICS_LOADER', name: 'orderGoods', loading: true });
        dispatch({ type: 'SET_STATISTICS_ERROR', name: 'orderGoods', error: null });
        debugger
        const filters = getState().statistics.orderGoods.filters;
        const params = {};
        if (filters.city && filters.city.value !== 'all') {
            params['city'] = filters.city.value;
        }

        if (filters.createdStartDate) {
            params['created_at_gte'] = moment(filters.createdStartDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        }
    
        if (filters.createdEndDate) {
            params['created_at_lte'] = moment(filters.createdEndDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        }

        return request({ method: 'get', url: urls.ordergoods+'/filteredOrderGoods', params })
            .then(result => {
                dispatch({ type: 'SET_STATISTICS_LOADER', name: 'orderGoods', loading: false });
                return result;
            })
            .catch(error => {
                dispatch({ type: 'SET_STATISTICS_ERROR', name: 'orderGoods', error });
                dispatch({ type: 'SET_STATISTICS_LOADER', name: 'orderGoods', loading: false });
            });
    }
}